import { render } from "./day-two-lunch.vue?vue&type=template&id=a21f5768"
import script from "./day-two-lunch.vue?vue&type=script&lang=js"
export * from "./day-two-lunch.vue?vue&type=script&lang=js"
script.render = render

export default script